import { Avatar, Link, Paper, Stack, Typography } from '@mui/material';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useIsDesktop } from 'Hooks';
import { NewRequestButton } from 'Images';

export const NewMedicalRequest = () => {
  const isDesktop = useIsDesktop();
  return (
    <Link
      underline={'none'}
      color={'inherit'}
      href={`${process.env.REACT_APP_REDIRECT_URL}UniversalRequest/1/1/77`}
      width={'fit-content'}
    >
      <Paper
        sx={{
          backgroundColor: '#fff',
          border: '1px solid',
          borderColor: isDesktop ? 'primary.shade_200' : 'primary.shade_400',
          width: isDesktop ? '189px' : '102px',
          height: isDesktop ? '111px' : '100px',
          borderRadius: '8px',
          boxShadow: isDesktop
            ? '0px 1px 20px rgba(8, 30, 84, 0.1)'
            : '0px 1px 22px rgba(21, 82, 232, 0.12)',
        }}
      >
        <Stack
          direction={isDesktop ? 'row' : 'column'}
          gap={isDesktop ? '12px' : '2px'}
          height={'100%'}
          alignItems={'center'}
          padding={isDesktop ? '12px 16px' : '18px 10px 12px'}
        >
          <Avatar
            src={NewRequestButton}
            alt={''}
            sx={{
              width: isDesktop ? '40px' : '32px',
              height: isDesktop ? '40px' : '32px',
            }}
          />
          <Typography
            fontSize={'16px'}
            fontWeight={600}
            lineHeight={'18px'}
            textAlign={isDesktop ? 'left' : 'center'}
            color={'text.secondary'}
          >
            {Dictionary[DICTIONARY.MedicalReferrals].newMedicalRequest}
          </Typography>
        </Stack>
      </Paper>
    </Link>
  );
};
